module.exports = __webpack_public_path__ + "static/media/seth.34fe20ca.png";